import { useEffect, useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { ArrowRight, Download, LockKeyhole, Mail, Smartphone } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../lib/supabase'

export function Login() {
  const { user, profile, loading } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [sending, setSending] = useState(false)
  const [installPrompt,setInstallPrompt]=useState<any>(null)
  const [iosHelp,setIosHelp]=useState(false)

  useEffect(()=>{
    const handler=(event:any)=>{event.preventDefault();setInstallPrompt(event)}
    window.addEventListener('beforeinstallprompt',handler)
    return()=>window.removeEventListener('beforeinstallprompt',handler)
  },[])

  async function installApp(){
    if(installPrompt){await installPrompt.prompt();await installPrompt.userChoice;setInstallPrompt(null);return}
    const ios=/iphone|ipad|ipod/i.test(navigator.userAgent)
    if(ios){setIosHelp(true);return}
    setIosHelp(true)
  }

  if (!loading && user && profile?.active) return <Navigate to={profile.role==='waiter'?'/garcom':'/painel'} replace />

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    setSending(true)

    const { error: authError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    })

    if (authError) {
      setError('E-mail ou senha inválidos.')
    } else {
      const target = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname
      navigate(target || '/painel', { replace: true })
    }
    setSending(false)
  }

  return <main className="login-page">
    <section className="login-art"><div className="eyebrow">GESTÃO • PEDIDOS • EXPERIÊNCIA</div><h1>O ritmo da casa,<br/><em>em uma só tela.</em></h1><p>Operação integrada para salão, cozinha, bar e caixa.</p><div className="pulse-orb"/></section>
    <section className="login-panel"><form onSubmit={submit}>
      <div className="brand login-brand"><span className="brand-mark">G</span><div><strong>GONÇALO</strong><small>Music Bar</small></div></div>
      <div><span className="eyebrow dark">ACESSO DA EQUIPE</span><h2>Bem-vindo de volta</h2><p>Entre com sua credencial de funcionário.</p></div>
      <label>E-mail<div className="input-wrap"><Mail size={18}/><input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="voce@goncalomusicbar.com.br" autoComplete="email" required/></div></label>
      <label>Senha<div className="input-wrap"><LockKeyhole size={18}/><input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" minLength={6} required/></div></label>
      {error && <div className="form-error" role="alert">{error}</div>}
      <button className="primary-button" disabled={sending}>{sending ? 'Entrando…' : 'Entrar no sistema'}<ArrowRight size={19}/></button>
      <button type="button" className="ghost-button" onClick={installApp}><Download size={18}/> Instalar no celular</button>
      {iosHelp&&<div className="notice"><Smartphone size={18}/><span><b>Instalar aplicativo:</b> no iPhone toque em Compartilhar e depois em “Adicionar à Tela de Início”. No Android, abra o menu do navegador e escolha “Instalar app” ou “Adicionar à tela inicial”.</span></div>}
      <small className="safe-note">Acesso protegido e ações registradas.</small>
    </form></section>
  </main>
}
